import { SelectionData } from '../../../models/util.model'
import {
  FileDownloadType,
  FileUpdateMethod,
  FileUpdateType,
} from '../models/file.types'

export const FILE_UPDATE_TYPES: SelectionData<FileUpdateType>[] = [
  {
    label: 'XLS',
    value: 'XLS',
    icon: 'fad fa-file-spreadsheet',
  },
]

export const FILE_DOWNLOAD_TYPES: SelectionData<FileDownloadType>[] = [
  {
    label: 'Empty',
    value: 'EMPTY',
    icon: 'fad fa-file',
  },
  {
    label: 'Filled',
    value: 'FILLED',
    icon: 'fad fa-file-alt',
  },
]

export const FILE_UPDATE_METHODS: SelectionData<FileUpdateMethod>[] = [
  {
    label: 'Set value',
    value: 'set',
    icon: 'fad fa-share',
  },
  {
    label: 'Delete value',
    value: 'unset',
    icon: 'fad fa-window-close',
  },
  {
    label: 'Add value',
    value: 'push',
    icon: 'fad fa-layer-plus',
  },
  {
    label: 'Remove value',
    value: 'pull',
    icon: 'fad fa-layer-minus',
  },
  {
    label: 'Sum value',
    value: 'add',
    icon: 'fas fa-plus',
  },
  {
    label: 'Subtract value',
    value: 'subtract',
    icon: 'fas fa-minus',
  },
  {
    label: 'Multiply value',
    value: 'multiply',
    icon: 'fas fa-times',
  },
  {
    label: 'Divide value',
    value: 'divide',
    icon: 'fas fa-divide',
  },
]
